import { Button } from '@/components/ui/button';
import { Modal } from '@/components/ui/modal';
import { api } from '@/redux/api';

type ConfirmResetModalProps = {
  isOpen: boolean;
  onCancel: () => void;
  onSend: () => void;
  unitId: number;
  organisationId: number;
};

export default function ConfirmResetModal({
  isOpen,
  onCancel,
  onSend,
  unitId,
  organisationId,
}: ConfirmResetModalProps) {
  const [resetUnit] = api.useResetUnitMutation();

  return (
    <Modal
      buttonItems={[
        <Button key="cancel" onClick={onCancel} variant="secondary">
          Cancel
        </Button>,
        <Button
          key="confirm"
          onClick={async () => {
            onSend();
            await resetUnit({
              organisationId,
              unitId,
              actionType: 'resetUnit',
            });
          }}
          variant="primary"
        >
          Reset Unit
        </Button>,
      ]}
      open={isOpen}
      setOpen={onCancel}
      title="Confirm Reset"
    >
      <div>
        <p>
          Are you sure you want to reset this unit? This will remove all
          notifications, alarms, timers, and reminders.
        </p>
      </div>
    </Modal>
  );
}
